import React, { useState } from 'react';
import TitleSection from 'components/common/TitleSection';
import CommonTab from 'components/common/tabs';
import SubPagesLayout from 'layouts/SubPagesLayout';
import TabsListing from 'components/common/tabs/TabsListing';
import {
    privateBirthdayData,
    nikkahData,
    mayonData,
    walimaData,
    baraatData,
    privateCardData,
    nikkahCardData,
    walimaCardData,
    baraatCardData,
    mayonCardData,
    privateDetailPage
} from 'helpers/portfolioHelper';
import CommonDetail from 'components/common/CommonDetail';

const PrivatePage = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'PRIVATE EVENTS',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  const [currentTab, setCurrentTab] = useState('Birthday');

  let [tabList] = useState([
    {
      id: 1,
      name: 'Birthday',
      component: (
        <TabsListing
          list={privateBirthdayData.slice(1, 6)}
          cardData={privateCardData}
        />
      ),
    },
    {
      id: 2,
      name: 'Nikkah',
      component: (
        <TabsListing
          list={nikkahData.slice(1, 6)}
          cardData={nikkahCardData}
        />
      ),
    },
    {
      id: 3,
      name: 'Mayon',
      component: (
        <TabsListing
          list={mayonData.slice(1, 6)}
          cardData={mayonCardData}
        />
      ),
    },
    {
      id: 4,
      name: 'Baraat',
      component: (
        <TabsListing
          list={baraatData.slice(1, 6)}
          cardData={baraatCardData}
        />
      ),
    },
    {
      id: 5,
      name: 'Walima',
      component: (
        <TabsListing
          list={walimaData.slice(1, 6)}
          cardData={walimaCardData}
        />
      ),
    }
  ]);
  return (
    <>
      <section className='DBlock relative py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
        <div className='max-w-7xl mx-auto'>
        <CommonDetail data={privateDetailPage}/>
          <div>
            <TitleSection titleDetail={titleDetail} />
            <CommonTab
              tabList={tabList}
              setCurrentTab={setCurrentTab}
              currentTab={currentTab}
              maxWidth='max-w-xl'
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default SubPagesLayout({ route: 'what we do/private event' })(
    PrivatePage
  ); ;
